import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionTemplateEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createExportPermissionTemplateUseCase({ membershipRepository }: Deps) {
  return async function exportPermissionTemplate(orgId: string): Promise<PermissionTemplateEntity> {
    return membershipRepository.exportPermissionTemplate(orgId);
  };
}
